module.exports = __webpack_public_path__ + "static/media/google.df129b68.svg";